var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.652 5.894L.106 3.331a.362.362 0 010-.513l.515-.512a.365.365 0 01.514 0L2.909 4.1 6.865.106a.365.365 0 01.514 0l.514.513a.36.36 0 010 .512L3.166 5.894a.365.365 0 01-.514 0",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgCheckmark;